
import { create } from "zustand";
import { API_BASE_URL, API_BASE_URL1 } from "../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../utils/apiCall";

const CommercialCollectionReportStore = create((set, get) => ({

    commercialReportsData: [],
    loading: false,
    error: false,

    fetchCommercialCollectionReportsApi: async (fromDate,toDate,zoneId,vehicleNumber) => {
        set({ loading: true, error: null });
        try {
            const url = 
            `${API_BASE_URL1}CollectionReport/PrimaryVehicleTripCommercialCollectionSummary?fromDate=${fromDate}&toDate=${toDate}&zone=${zoneId}&vehicleNumber=${vehicleNumber}`;

            const reportsData = await apiCall({
                url,
                method: "get",
                token: localStorage.getItem("token"),
            });
            set({
                commercialReportsData: Array.isArray(reportsData) ? reportsData : [],
                loading: false
            });

        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");
            if (error.response && error.response.status === 404) {
                set({
                    commercialReportsData: [], // fixed typo: commercialReportsData → commercialReportsData
                    error: "No Data found.",
                    loading: false
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        }
    },
}));

export default CommercialCollectionReportStore
